import React, { useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import api from '../../services/api';
import { showToast } from '../../hooks/useToast';

const Enrollments = () => {
  const [stats, setStats] = useState({ total: 0, synced: 0, percentage: 0 });
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await api.get('/enrollments/stats');
      const enrollStats = response.data.Enrollment || { total: 0, synced: 0, percentage: 0 };
      setStats(enrollStats);
    } catch (error) {
      showToast('Error cargando estadísticas de matriculaciones', 'danger');
    }
  };

  const migrateEnrollments = async () => {
    if (isProcessing) return;
    setIsProcessing(true);
    
    try {
      showToast('Migrando matriculaciones...', 'info');
      const response = await api.post('/enrollments/enroll-batch');
      showToast(`Matriculaciones procesadas: ${response.data.processed} elementos`, 'success');
      await loadStats();
    } catch (error) {
      showToast('Error migrando matriculaciones', 'danger');
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Gestión de Matriculaciones</h2>
      </div>

      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Matriculaciones</h6>
            <i className="bi bi-person-plus text-info"></i>
          </div>
          <div className="row text-center">
            <div className="col-4">
              <div className="h4 text-info">{stats.synced}</div>
              <small className="text-muted">Procesadas</small>
            </div>
            <div className="col-4">
              <div className="h4 text-secondary">{stats.total}</div>
              <small className="text-muted">Total</small>
            </div>
            <div className="col-4">
              <div className="h4 text-primary">{stats.percentage}%</div>
              <small className="text-muted">Progreso</small>
            </div>
          </div>
          <Button 
            variant="info" 
            className="w-100 mt-3"
            onClick={migrateEnrollments}
            disabled={isProcessing}
          >
            <i className="bi bi-cloud-upload me-1"></i>
            Procesar Matriculaciones
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Enrollments;